<template>
  <!-- Карточка во всю высоту колонки: карточки одного ряда равны по высоте, а
       кнопки прижаты к низу (просьба Глеба 03.10.2026). -->
  <v-card
    class="mx-auto disable-max-width service-card d-flex flex-column"
    max-width="344"
    height="100%"
    outlined
  >
    <!-- Картинка во всю ширину карточки, пропорции как у исходников (с 03.10.2026
         это широкие картины с надписями): высота идёт за шириной, ничего не
         обрезается по бокам, и надписи остаются целыми. -->
    <v-img
      :src="resolvedImage"
      :aspect-ratio="1280 / 700"
      class="mobile-hide flex-grow-0"
    ></v-img>

    <div class="d-flex flex-column flex-grow-1">
      <v-card-title class="service-card__title">
        {{ $t(title) }}
      </v-card-title>
      <!-- Кнопки действий держим справа — единое правило по всему кабинету,
           главное действие крайнее справа. При переносе между кнопками
           остаётся промежуток. -->
      <v-card-actions class="service-card__actions justify-end flex-wrap mt-auto">
        <!-- Метка карточки, например «Тестовый режим». Стоит слева в строке
             кнопок: картинку карточки на телефоне прячем, а эта строка видна
             всегда. -->
        <v-chip
          v-if="badge"
          small
          label
          color="warning"
          class="me-auto"
        >
          {{ $t(badge) }}
        </v-chip>
        <!-- Вопросик и кнопки — одной группой: при нехватке места переносятся
             на новую строку вместе, а не по одному. -->
        <div class="service-card__buttons d-flex align-center flex-wrap justify-end">
          <!-- Значок-вопросик с подсказкой: у заказов — что такое график
               (клиенты путались, чем «Подать график» отличается от «Заказать»),
               у лицензий — что входит в услугу. -->
          <v-tooltip
            v-if="isScheduleExist === true || showHint === true || hint"
            top
            max-width="320"
          >
            <template #activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                size="20"
                class="info--secondary"
                v-on="on"
                @click.stop="showScheduleHint = !showScheduleHint"
              >
                {{ icons.mdiHelpCircleOutline }}
              </v-icon>
            </template>
            <span>{{ $t(hint || 'Здесь вы можете создать несколько заявок в один конкретный музей на разные группы и даты') }}</span>
          </v-tooltip>
          <v-btn
            v-if="isScheduleExist === true"
            color="secondary"
            outlined
            :href="scheduleLink"
          >
            {{ $t('Подать график') }}
          </v-btn>
          <v-btn
            color="primary"
            :href="link"
            outlined
          >
            {{ $t(actionTitle) }}
          </v-btn>
        </div>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
import { mdiHelpCircleOutline } from '@mdi/js'

export default {
  props: {
    title: String,
    image: String,
    link: String,
    isScheduleExist: Boolean,
    scheduleLink: String,

    // Надпись на главной кнопке, по умолчанию «Заказать».
    actionTitle: {
      type: String,
      default: 'Заказать',
    },

    // Метка на карточке, например «Тестовый режим». Пусто — метки нет.
    badge: {
      type: String,
      default: '',
    },

    // Своя подсказка у вопросика, например «Первичное получение, продление».
    // Пусто — подсказка про график (у заказов).
    hint: {
      type: String,
      default: '',
    },

    // Показать вопросик с подсказкой даже без кнопки графика: у «Билетов в
    // музеи» график убрали (множественная подача есть в «Заказать»), а
    // пояснение про несколько заявок оставили.
    showHint: Boolean,
  },
  data() {
    return {
      // Тап по вопросику на телефоне: наведения там нет, тултип открывается
      // кликом (v-tooltip Vuetify сам показывается по фокусу от клика).
      showScheduleHint: false,
      icons: { mdiHelpCircleOutline },
    }
  },
  computed: {
    resolvedImage() {
      // Картинки лежат в src/assets/images/travel-icons/ (WebP, ~60–90 КБ).
      // eslint-disable-next-line import/no-dynamic-require
      return require(`@/assets/images/travel-icons/${this.image}`)
    },
  },
}
</script>

<style scoped>
/* Vuetify по умолчанию рвёт заголовок карточки посреди слова
   («Консультационные ус луги»). Переносим по словам. */
.service-card__title {
  word-break: normal;
  overflow-wrap: break-word;
}

/* Промежуток между кнопками и при переносе на новую строку тоже. Отступ
   Vuetify между соседними кнопками убираем, чтобы не удваивать. */
.service-card__actions,
.service-card__buttons {
  gap: 8px;
}
.service-card__buttons > .v-btn + .v-btn {
  margin-left: 0;
}

@media (max-width: 767px) {
  .fixed-height {
    height: 200px;
  }
  .mobile-hide {
    display: none;
  }
  .disable-max-width {
    max-width: none !important;
  }
}
</style>
